<template>
  <div class="avatar-chart w-100">
    <b-container>
      <b-row>
        <b-col cols="auto">
          <svg
            class="avatar-chart"
            :width="svgWidth()"
            :height="svgHeight()"
            :viewBox="`0 0 ${svgWidth()} ${svgHeight()}`"
            :key="componentRefresh"
          >

            <svg 
              v-for="index in numAvatars" :key="'personal-'+index"
              :id="'avatar'+index"
              :ref="'avatar'+index"
              :x="getAvatarLayoutPosX(index)"
              :y="getAvatarLayoutPosY(index)"
              :height="getAvatarSize(index)"
              :width="getAvatarSize(index)"
              viewBox="0 0 50 50"
              preserveAspectRatio="xMinYMid meet"
            >
              <g
                id="Group"
                transform="translate(5.223,2.275)"
              >
                <circle
                  id="Ellipse_90"
                  data-name="Ellipse 90"
                  cx="20.170393"
                  cy="11.954237"
                  stroke-miterlimit="10"
                  r="11.801"
                  :style="`fill:none;stroke:${getAvatarColor(index)};stroke-width:3;stroke-linecap:round;stroke-miterlimit:10`"
                />
                <path
                  id="Path_303"
                  data-name="Path 303"
                  d="m -0.72360412,45.256238 c 0,-8.145 3.33899932,-14.538 9.77699952,-18.378"
                  stroke-miterlimit="10"
                  :style="`fill:none;stroke:${getAvatarColor(index)};stroke-width:3;stroke-linecap:round;stroke-miterlimit:10`"
                />
                <path
                  id="Path_304"
                  data-name="Path 304"
                  d="m 33.684394,28.792238 a 15.8,15.8 0 0 0 -11.472,-5.18"
                  stroke-miterlimit="10"
                  :style="`fill:none;stroke:${getAvatarColor(index)};stroke-width:3;stroke-linecap:round;stroke-miterlimit:10`"
                />
                <path
                  id="Path_305"
                  data-name="Path 305"
                  d="m 39.761394,45.399238 c 0.309,-6.646 -1.661,-12.224 -5.8,-16.3"
                  stroke-miterlimit="10"
                  :style="`fill:none;stroke:${getAvatarColor(index)};stroke-width:3;stroke-linecap:round;stroke-miterlimit:10`"
                />
              </g>
            </svg>
            <svg
              id="highlightedAvatarText"
              ref="highlightedAvatarText"
              :x="getAvatarLayoutPosX(accentuatedAvatarIndex)"
              :y="0"
              :height="getAvatarSize(accentuatedAvatarIndex)"
              :width="getAvatarSize(accentuatedAvatarIndex)"
              viewBox="0 0 50 50"
              preserveAspectRatio="xMinYMid meet"
            >
              <text
                :x="25"
                :y="25"
                text-anchor="middle"
                class="avatar-char__avatar-label"
                :style="`font-style:normal;font-weight:normal;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:${getAvatarColor(accentuatedAvatarIndex)};fill-opacity:1;stroke:none;stroke-width:1.49647403`"
              >
                {{ labelAvatar }}
              </text>
            </svg>
          </svg>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <div class="w-100 avatar-chart__spacer" ref="avatarChartWidthHelper"></div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="auto" class="mr-auto avatar-chart__legend avatar-chart__legend--grey">
          <span v-html="labelMin"></span>
        </b-col>
        <b-col cols="auto" class="avatar-chart__legend avatar-chart__legend--grey avatar-chart__legend--right">
          <span v-html="labelMax"></span>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>

  export default {
    name: 'AvatarChart',
    props: {
      values: Array,
      width: {
        type: Number,
        default: 300
      },
      height: {
        type: Number,
        default: 300
      },
      highlightColor: {
        type: String,
        default: "#369BA6"
      },
      mutedColor: {
        type: String,
        default: "#E5ECEF"
      },
      accentuatedAvatarIndex: {
        type: Number,
        default: 5
      },
      labelMin: {
        type: String,
        default: "Min"
      },
      labelMax: {
        type: String,
        default: "Max"
      },
      labelAvatar: {
        type: String,
        default: "You"
      }
    },
    data() {
      return {
        componentRefresh: 0,
        numAvatars: 10,
        avatarHeight: 60,
        avatarWidth: 50,
        accentuatedAvatarScalingFactor: 1.0,
        mutedAvatarScalingFactor: 0.7,
      };
    },
    mounted() {
    },
    methods: {
      svgHeight() {
        return this.svgWidth() * 0.18; // scaling ratio to determine svgHeight
      },
      accentuatedAvatarHeight() {
        return this.maxAvatarSize() * this.accentuatedAvatarScalingFactor;
      },
      mutedAvatarHeight() {
        return this.accentuatedAvatarHeight() * this.mutedAvatarScalingFactor;
      },
      accentuatedAvatarWidth() {
        return this.maxAvatarSize();
      },
      mutedAvatarWidth() {
        return this.accentuatedAvatarWidth() * this.mutedAvatarScalingFactor;
      },
      availableSpaceForAvatar() {
        return this.svgWidth() / this.numAvatars;
      },
      maxAvatarSize() {
        // calculates the maximum size an avatar can take up
        return (this.avatarWidth * (this.availableSpaceForAvatar() / this.avatarWidth)) * this.accentuatedAvatarScalingFactor
      },
      svgWidth() {
        if (this.$refs.avatarChartWidthHelper === undefined) {
          // we need to re-render the component, as during the first render the avatarChartWidthHelper
          // will be initialized and therefore we can't get the actual width of the component
          // to properly render the SVG image
          this.componentRefresh += 1;
          return this.width;
        }
        return this.$refs.avatarChartWidthHelper.clientWidth;
      },
      getAvatarSize(index) {
        if (index === this.accentuatedAvatarIndex) {
          return this.accentuatedAvatarWidth()
        }
        return this.mutedAvatarWidth()
      },
      getAvatarLayoutPosX(index) {
        let calculationIndex = index - 1;

        // we need to move all avatars after the accentuated one
        // to distribute them evenly across the horizontal axis
        if (index > this.accentuatedAvatarIndex) {
          let availableSpacing = (this.svgWidth() - (this.mutedAvatarWidth() * 9 + this.accentuatedAvatarWidth())) / this.numAvatars;
          return (this.maxAvatarSize() * calculationIndex) + Math.abs(availableSpacing)
        }

        return (this.maxAvatarSize()) * calculationIndex
      },
      getAvatarLayoutPosY(index) {
        if (index === this.accentuatedAvatarIndex) {
          // move the accentuated avatar vertically to make space for the text above
          return this.mutedAvatarHeight()
        }

        // move all muted avatars as well to align them vertically
        return this.mutedAvatarHeight() + (this.accentuatedAvatarHeight() - this.mutedAvatarHeight());
      },
      getAvatarColor(index) {
        if (index === this.accentuatedAvatarIndex) {
          return this.highlightColor;
        } else {
          return this.mutedColor;
        }
      },
      onResize() {
        // trigger re-render component to accommodate new dimensions
       this.componentRefresh += 1
      }
    },
    mounted() {
      window.addEventListener('resize', this.onResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize)
    }
  };
</script>
<style lang="scss" scoped>
  .avatar-char__avatar-label{
    font-size: 2rem;
    @media screen and (min-width: 992px) {
      font-size: 1rem;
    } 
  }

  .avatar-chart__legend {
    font-size: 0.85rem;
  }

  .avatar-chart__legend--grey {
    color: #707070;
  }

  .avatar-chart__legend--right {
    text-align: right;
  }

  .avatar-chart__spacer {
    min-height: 1px;
    display: block;
  }
</style>
